<template>
  <div class="content-wrapper">
    <!-- <img src> -->
    <div class="label-text">{{headerTab}}</div>
    <div class="small-text">corporation</div>
    <div class="threeColumnGrid margintop-20">
      <div class="left-col">
        <h3>Registered Office</h3>
        <div class="addr">
          <label>
            <!-- Opp Wilson Pen, 115, 4th Floor, Raaj Chambers, Old Nagardas Road, Paramhans Marg, Andheri East, Mumbai,
            Maharashtra 400069 -->
            {{legalEntity.registeredAddress.locality}},{{legalEntity.registeredAddress.city}},{{legalEntity.registeredAddress.state}},{{legalEntity.registeredAddress.pincode}}
          </label>
        </div>
      </div>
      <div class="mid-col">
        <h3>Head Office</h3>
        <div class="addr">
          <label>
            Opp Wilson Pen, 115, 4th Floor, Raaj Chambers, Old Nagardas Road, Paramhans Marg, Andheri East, Mumbai,
            Maharashtra 400069
          </label>
        </div>
      </div>
      <div class="right-col">
        <!-- <h3>Registered Office</h3>
        <div class="addr">
          <label>
            Opp Wilson Pen, 115, 4th Floor, Raaj Chambers, Old Nagardas Road, Paramhans Marg, Andheri East, Mumbai,
            Maharashtra 400069
          </label>
        </div>-->
      </div>
    </div>

    <div class="company-details">
      <h3>Company Identification Details</h3>
      <div class="row">
        <div class="col-3">
          <div class="label-text">CIN Number</div>
          <p>L74140MH2000PLC124008</p>
        </div>
        <div class="col-3">
          <div class="label-text">TAN Number</div>
          <p>L74140MH2000PLC124008</p>
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <div class="label-text">PAN Number</div>
          <p>L74140MH2000PLC124008</p>
        </div>
        <div class="col-3">
          <div class="label-text">TAN Circle</div>
          <p>L74140MH2000PLC124008</p>
        </div>
      </div>
    </div>

    <div class="company-details">
      <h3>Invoicing Details</h3>
      <div class="label-text">GST Number</div>
      <p>L74140MH2000PLC124008</p>
    </div>
    <tl-checkbox
      class="headcheck checkBox"
      label="Same As Registered Office"
      v-model="formData.location"
      @change="changeHandler"
    />
    <div class="group-btn">
      <btn-grp>
        <btn text="Edit" type="secondary" @click="editDetails"/>
      </btn-grp>
    </div>
    <div class="row">
       <div class="col-3 marginbot-20" v-for="(paySlip,index) of PaySlipTypes" :key="index">
            <pay-slip-details :paySlipType="paySlip"/>
       </div>
    </div>
  </div>
</template>
<script>
import paySlipDetails from './paySlipDetails.vue';
export default {
  components:{ paySlipDetails },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    headerTab: String,
    legalEntity:Object
  },
  computed:{

  },
  activated:{
    getentityDetails(){
      //console.log('entityDetails',legalEntity);
    }
  },
  data() {
    return {
      formData: {},
      PaySlipTypes:['PayGroup','Location','Business','BusinessTypes','Cost Center']
    };
  },
  methods: {

    changeHandler(event) {
      //console.log("logValue", event);
    },
    editDetails() {}
  }
};
</script>
<style lang="scss" scoped>
.addr label {
  width: 33.3%;
  word-wrap: break-word;
  line-height: 30px;
}
.left-col,
.mid-col,
.right-col {
  width: 70%;
}
.company-details {
  margin-top: 20px;
  h3 {
    margin-bottom: 20px;
  }
  p {
    font-size: 14px;
    color: #9c9c9c;
  }
}
</style>


